'use client';

import { useCallback, useMemo } from 'react';
const useOptions = (entries, initialEntry, selectedEntry, toLabel, toValue, comparator = (option, selectedEntry_0) => option.value === selectedEntry_0) => {
  const optionMaker = useCallback(entry => ({
    label: toLabel(entry),
    value: toValue(entry)
  }), [toLabel, toValue]);
  const options = useMemo(() => entries.map(optionMaker), [entries, optionMaker]);
  const selectedOption = useMemo(() => options.find(option_0 => comparator(option_0, selectedEntry)), [options, selectedEntry, comparator]);
  const initialOption = useMemo(() => options.find(option_1 => comparator(option_1, initialEntry)), [options, initialEntry, comparator]);
  return useMemo(() => ({
    options,
    selectedOption,
    initialOption
  }), [options, selectedOption, initialOption]);
};
export default useOptions;